import { For } from 'shared';

import { useSubAccounts } from 'features/subAccounts/hooks/useSubAccounts';

import { SubAccountMenuItem } from './SubAccountMenuItem';

export const SubAccountsMenu = () => {
  const { subAccounts, handleSubAccountSelect } = useSubAccounts();

  return (
    <For each={subAccounts}>
      {(account) => (
        <SubAccountMenuItem
          key={account.userId}
          onSelect={handleSubAccountSelect}
          account={account}
        />
      )}
    </For>
  );
};
